var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    {
      staticClass: "absolute transition-all duration-300",
      style: { top: _vm.position.top, left: _vm.position.left }
    },
    [
      _c(
        "div",
        {
          staticClass:
            "border-l-4 rounded-xl bg-pure-white transition-all duration-300",
          style: {
            height: _vm.assets.height,
            width: _vm.assets.width,
            borderColor: _vm.isOpenRoom ? _vm.borderOpenRoom : _vm.borderColor
          },
          attrs: { id: "recurring-slot" }
        },
        [
          _c(
            "div",
            {
              staticClass:
                "h-full w-full py-1 px-1 flex flex-col justify-between gap-1 border-2 border-l-0 border-dashed rounded-lg",
              style: { borderColor: _vm.borderColor }
            },
            [
              _c(
                "div",
                {
                  staticClass: "relative h-full w-full py-1 px-1.5 rounded",
                  style: { backgroundColor: _vm.backgroundColor }
                },
                [
                  _vm.error
                    ? _c(
                        "div",
                        {
                          staticClass: "h-full flex gap-1",
                          class: {
                            "items-center":
                              _vm.isCompact && _vm.periodCount === 1,
                            "flex-col justify-center":
                              !_vm.isCompact || _vm.periodCount > 1
                          }
                        },
                        [
                          _c("BlIcon", {
                            staticClass: "h-6 w-6",
                            attrs: { icon: "warning", color: "error" }
                          }),
                          _vm._v(" "),
                          _c("BlTextSubtitle3", {
                            staticClass: "truncate",
                            style: { color: _vm.textColor },
                            attrs: { text: "Conflicting timeslot" }
                          }),
                          _vm._v(" "),
                          !_vm.isCompact || _vm.periodCount > 1
                            ? _c("BlTextBody2", {
                                style: { color: _vm.textColor },
                                attrs: { text: "Please review" }
                              })
                            : _vm._e()
                        ],
                        1
                      )
                    : _c(
                        "div",
                        {
                          staticClass: "h-full flex gap-1 truncate",
                          class: {
                            "items-center justify-between":
                              _vm.isCompact && _vm.periodCount === 1,
                            "flex-col justify-center":
                              !_vm.isCompact || _vm.periodCount > 1,
                            "pt-2": _vm.isOpenRoom
                          }
                        },
                        [
                          _vm.client.name &&
                          (!_vm.isCompact || _vm.periodCount > 1)
                            ? _c("BlTextSubtitle3", {
                                staticClass: "truncate",
                                style: { color: _vm.textColor },
                                attrs: { text: "" + _vm.client.name }
                              })
                            : _vm._e(),
                          _vm._v(" "),
                          _vm.therapist.name
                            ? _c("BlTextSubtitle3", {
                                staticClass: "truncate",
                                style: { color: _vm.textColor },
                                attrs: { text: "" + _vm.therapist.name }
                              })
                            : _vm._e(),
                          _vm._v(" "),
                          !_vm.isCompact ||
                          (_vm.isOpenRoom && _vm.periodCount > 2) ||
                          (!_vm.isOpenRoom && _vm.periodCount > 1)
                            ? _c("BlTextBody2", {
                                style: { color: _vm.textColor },
                                attrs: {
                                  text:
                                    _vm.period.start_time_string +
                                    " - " +
                                    _vm.period.end_time_string
                                }
                              })
                            : _vm._e(),
                          _vm._v(" "),
                          !_vm.isCompact &&
                          _vm.periodCount > 1 &&
                          _vm.enableBranch &&
                          _vm.room &&
                          _vm.room.branch
                            ? _c("BlTextBody2", {
                                staticClass: "truncate",
                                style: { color: _vm.textColor },
                                attrs: { text: "" + _vm.room.branch.name }
                              })
                            : _vm._e(),
                          _vm._v(" "),
                          _vm.room.name
                            ? _c("BlTextBody2", {
                                staticClass: "truncate min-w-16",
                                style: { color: _vm.textColor },
                                attrs: { text: "" + _vm.room.name }
                              })
                            : _vm._e()
                        ],
                        1
                      )
                ]
              )
            ]
          ),
          _vm._v(" "),
          _vm.isOpenRoom
            ? _c(
                "div",
                {
                  staticClass:
                    "border border-l-4 rounded-t-lg px-4 w-full absolute top-0 left-0 flex items-center justify-center",
                  style: {
                    height: _vm.isCompact ? "1.25rem" : "1.625rem",
                    borderColor: _vm.borderOpenRoom,
                    backgroundColor: _vm.backgroundOpenRoom
                  }
                },
                [
                  _c(
                    "div",
                    { staticClass: "flex justify-center truncate" },
                    [
                      _c("BlTextBody2", {
                        staticClass: "truncate",
                        style: { color: _vm.textColorOpenRoom },
                        attrs: { text: "Open room" }
                      })
                    ],
                    1
                  )
                ]
              )
            : _vm._e()
        ]
      )
    ]
  )
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-66a57156", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-66a57156","hasScoped":false,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/appointments/overlay/SlotRecurring.vue
// module id = null
// module chunks = 